import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("p", { class: "UiPage_sectionTitle" }, "rwd font sizes (px presented for large screens)", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", { class: "ui-txt-xxs" }, "Text size xxs 15px", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", { class: "ui-txt-xs" }, "Text size xs 19px", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", { class: "ui-txt-sm" }, "Text size sm 24px", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", { class: "ui-txt-md" }, "Text size md 30px", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", { class: "ui-txt-lg" }, "Text size lg 44px", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("p", { class: "ui-txt-xl" }, "Text size xl 72px", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("p", { class: "ui-txt-xxl" }, "Text size xxl 90px", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("p", { class: "ui-txt-xxxl" }, "Text size xxxl 140px", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("p", { class: "UiPage_sectionTitle" }, "Buttons", -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("p", { class: "ui-btn is-md is-black" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-home" }),
  /*#__PURE__*/_createTextVNode(" Black button ")
], -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("p", { class: "ui-btn is-md is-black is-animated" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-home" }),
  /*#__PURE__*/_createTextVNode(" Hover animated button ")
], -1)
const _hoisted_13 = { class: "ui-btn is-sm is-black is-animated" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("span", { class: "ui-btn_label" }, "Back", -1)
const _hoisted_15 = { class: "ui-btn is-sm is-black is-animated" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("span", { class: "ui-btn_label" }, "Next", -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("p", { class: "ui-btn is-xxs" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-home" }),
  /*#__PURE__*/_createTextVNode(" Button xxs 15px ")
], -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("p", { class: "ui-btn is-xs" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-home" }),
  /*#__PURE__*/_createTextVNode(" Button xs 19px ")
], -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("p", { class: "ui-btn is-sm" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-home" }),
  /*#__PURE__*/_createTextVNode(" Button sm 24px ")
], -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("p", { class: "ui-btn is-md" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-home" }),
  /*#__PURE__*/_createTextVNode(" Button md 30px ")
], -1)
const _hoisted_21 = /*#__PURE__*/_createElementVNode("p", { class: "ui-btn is-lg" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-home" }),
  /*#__PURE__*/_createTextVNode(" Button lg 44px ")
], -1)
const _hoisted_22 = /*#__PURE__*/_createElementVNode("p", { class: "ui-btn is-xl" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-home" }),
  /*#__PURE__*/_createTextVNode(" Button xl 72px ")
], -1)
const _hoisted_23 = /*#__PURE__*/_createElementVNode("p", { class: "ui-btn is-xxl" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-home" }),
  /*#__PURE__*/_createTextVNode(" Button xxl 90px ")
], -1)
const _hoisted_24 = /*#__PURE__*/_createElementVNode("p", { class: "ui-btn is-xxxl" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-home" }),
  /*#__PURE__*/_createTextVNode(" Button xxxl 140px ")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_header = _resolveComponent("ion-header")!
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, { id: "UiPage" }, {
    default: _withCtx(() => [
      _createVNode(_component_ion_header, null, {
        default: _withCtx(() => [
          _createTextVNode(" header ")
        ]),
        _: 1
      }),
      _createVNode(_component_ion_content, { class: "ion-padding" }, {
        default: _withCtx(() => [
          _hoisted_1,
          _hoisted_2,
          _hoisted_3,
          _hoisted_4,
          _hoisted_5,
          _hoisted_6,
          _hoisted_7,
          _hoisted_8,
          _hoisted_9,
          _hoisted_10,
          _hoisted_11,
          _hoisted_12,
          _createTextVNode(" Icon button "),
          _createElementVNode("span", _hoisted_13, [
            _createVNode(_component_ion_icon, { src: _ctx.chevronBackOutline }, null, 8, ["src"]),
            _hoisted_14
          ]),
          _createElementVNode("span", _hoisted_15, [
            _hoisted_16,
            _createVNode(_component_ion_icon, { src: _ctx.chevronForwardOutline }, null, 8, ["src"])
          ]),
          _hoisted_17,
          _hoisted_18,
          _hoisted_19,
          _hoisted_20,
          _hoisted_21,
          _hoisted_22,
          _hoisted_23,
          _hoisted_24
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}